module.exports = {"payments":{"types":["bank","direct_debit","credit_card","credit","cash","cheque","debit_card","representation","correction","payjet_direct_debit","payjet_credit_card","payjet_other","other"],"pos_types":["cash","debit_card","credit_card","representation","cheque"],"states":["success","pending","failed"]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deposits/billing.json
// module id = 2378
// module chunks = 1